import React from "react";
import { Link } from "react-router-dom";
import './button.styles.scss';

const Button = ({func, text, mailto, label, loc}) => {
    // return (
    //     <div 
    //         // style={{ 
    //         //     color: `${!bg ? 'white' : 'black'}`,
    //         //     backgroundColor: bg,
    //         //     borderColor: bg,
    //         // }}
    //         className="button" 
    //         onClick={func}
    //     >{text}</div>
    // )


    const toMail  = (e) => {
        window.location.href = mailto;
        e.preventDefault();
        window.prompt("Manually copy the Gmail address below if you are not redirected.", "treegotyou@gmail.com");
    }

    return (
        <Link className="button" style={{
            textDecoration: 'inherit',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
            }}
            to={!loc ? '#' : loc}
            onClick={!mailto ? func : toMail}
        >
            {!text ? label : text}
        </Link>
    );
}

export default Button;